export default theme => ({

  root: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'

  }

})



// WEBPACK FOOTER //
// ./src/styles/components/LoadingPage.js